import React from 'react';

import { Paper, Radio, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';

import { useChangeModal } from '../../ChangeModalContext';
import { ChangeTiming } from '../../changeModalSteps';

const TimingStep: React.FC = () => {
  const { form, athletePackage } = useChangeModal();

  const tomorrow = dayjs().add(1, 'day').format('ddd, MMM D, YYYY');
  const whenEnds = athletePackage.endDate
    ? dayjs(athletePackage.endDate).add(1, 'day').format('ddd, MMM D, YYYY')
    : null;

  return (
    <Stack>
      <Text size='sm' c='dimmed'>
        Choose when the new package should take effect.
      </Text>

      <Radio.Group
        value={form.values.timing ?? ''}
        onChange={value => form.setFieldValue('timing', value as ChangeTiming)}
        error={form.errors.timing}
        name='timing'
      >
        <Stack spacing='sm'>
          <Paper p='md' withBorder>
            <Radio
              value='TOMORROW'
              label={
                <Stack spacing={2}>
                  <Text fw={600}>Apply change starting tomorrow</Text>
                  <Text size='sm' c='dimmed'>
                    Current package ends today. New package starts {tomorrow}.
                  </Text>
                </Stack>
              }
            />
          </Paper>

          <Paper p='md' withBorder sx={whenEnds ? undefined : { opacity: 0.5, pointerEvents: 'none' }}>
            <Radio
              value='WHEN_ENDS'
              disabled={!whenEnds}
              label={
                <Stack spacing={2}>
                  <Text fw={600}>When the current package ends</Text>
                  <Text size='sm' c='dimmed'>
                    {whenEnds
                      ? `New package starts ${whenEnds}.`
                      : 'Not available — this package has no scheduled end date.'}
                  </Text>
                </Stack>
              }
            />
          </Paper>
        </Stack>
      </Radio.Group>
    </Stack>
  );
};

export default TimingStep;
